import { Loader } from "./Loader";
import { Input } from "./Input";

export class Sampler {

    public inputs: Input[];

    public loadBlob(dataView: DataView, loader: Loader) {
        let offset = 0;

        let inputListResult = loader.util.readIdentityList<Input>(dataView, offset);
        this.inputs = inputListResult.items;
        offset = inputListResult.offset;
    }

    public getInput(semantic: string): Input {
        let input = this.inputs.find(input => input.semantic == semantic)

        return input ? input : null;
    }
}
